define(['underscore', 'text!./templates/wizard-sidebar-additional.html'],
    (_, templateStr)=> {
        return ['ModalService', 'qnb.EmailService', '$q', 'StateUtils', '$state', '$translate', 'LocaleService',
            (ModalService, QuoteEmailService, $q, StateUtils, $state, $translate, LocaleService)=> {
                return {
                    restrict: 'A',
                    template: templateStr,
                    link: (scope)=> {
                        scope.quoteNumber = ()=> {
                            const submission = StateUtils.activeDataForState(true).flowModel.snapshot.value;
                            return submission ? submission.quoteID : null;
                        };

                        scope.emailQuote = ()=> {
                            const submission = StateUtils.activeDataForState(true).flowModel.snapshot.value;
                            const acctHolder = _.findWhere(submission.persons, {accountHolder: true});
                            const emailInfo = {
                                quoteID: submission.quoteID,
                                sessionID: submission.sessionUUID,
                                language: LocaleService.getLocaleDisplayName(),
                            };

                            $q.when(QuoteEmailService.emailQuote('quoteandbind', emailInfo), ()=> {
                                ModalService.showInfo(
                                    'quoteandbind.directives.QnbWizardButtons.Quote Emailed',
                                    $translate('quoteandbind.directives.QnbWizardButtons.The quote details have been emailed', {emailAddress: acctHolder.emailAddress1}));
                            }, ()=> {
                                ModalService.showError(
                                    'quoteandbind.directives.QnbWizardButtons.Error',
                                    'quoteandbind.directives.QnbWizardButtons.Sorry, we were not able to email the quote details at this time.');
                            });
                        };

                        scope.submissionCreated = ()=> {
                            const submission = StateUtils.activeDataForState(true).flowModel.snapshot.value;
                            return submission.submissionExists() && submission.draftData.accountHolder.emailAddress1;
                        };
                    },
                };
            }];
    });



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/common/directives/WizardSidebarAdditional.js